<span class="min-w-0 truncate whitespace-nowrap">{{ label() }}</span>

<button
  type="button"
  class="inline-flex size-5 shrink-0 items-center justify-center rounded-full text-base leading-none font-bold text-sky-900 transition-colors hover:bg-red-100 hover:text-red-600 focus-visible:bg-red-100 focus-visible:text-red-600 focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-red-600 active:text-red-700"
  [attr.aria-label]="removeAriaLabel()"
  [attr.data-testid]="'removable-tag-remove-' + label()"
  (click)="removed.emit()">
  ×
</button>
